import {faBars} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import React, {useContext} from "react"
import {ProfileContext} from "../../../context/Profile.context"
import {useAvatar} from "../../../hooks/useAvatar"
import {Keys} from "../../../interfaces/keys"
import styles from "./index.module.scss"

interface ProfileButtonProps {
  keys?: Keys | null
}

export const ProfileButton = (props: ProfileButtonProps) => {
  const {profile, profileReplCnt} = useContext(ProfileContext)
  const {avatar} = useAvatar(profile, profileReplCnt)
  const keys = props.keys

  switch (keys) {
    case undefined:
      return null
    case null:
      return (
        <div>
          My Wallet
        </div>
      )
    default:
      return (
        <div className={styles.ProfileContainer}>
          <img src={avatar} alt="Profile picture" className={styles.ProfilePicture}/>
          <FontAwesomeIcon icon={faBars} className={styles.ProfileMenuIcon}/>
        </div>
      )
  }
}
